const rails = new Set();
let resizeFrame = 0;
let watchingResize = false;

function updateScrollableRails() {
    if (resizeFrame) return;
    resizeFrame = window.requestAnimationFrame(() => {
        resizeFrame = 0;
        const measurements = [];
        rails.forEach((rail) => {
            if (!rail.isConnected) {
                rail.zirbelinoResizeObserver?.disconnect();
                rails.delete(rail);
                return;
            }
            measurements.push([rail, rail.scrollWidth > rail.clientWidth + 2]);
        });
        measurements.forEach(([rail, scrollable]) => {
            rail.classList.toggle('is-drag-scrollable', scrollable);
        });
    });
}

export function initDragScroll(rail) {
    if (rail.dataset.dragScrollReady === 'true') return;
    rail.dataset.dragScroll = '';
    rail.dataset.dragScrollReady = 'true';
    rails.add(rail);
    if (!watchingResize) {
        watchingResize = true;
        window.addEventListener('resize', updateScrollableRails, { passive: true });
    }

    let gesture = null;
    let suppressClick = false;
    let dragFrame = 0;
    const applyDrag = () => {
        dragFrame = 0;
        if (gesture?.dragging) rail.scrollLeft = gesture.pendingLeft;
    };
    rail.addEventListener('pointerdown', (event) => {
        const nestedRail = event.target.closest?.('[data-drag-scroll]');
        if (nestedRail && nestedRail !== rail) return;
        if (
            event.pointerType !== 'mouse' ||
            event.button !== 0 ||
            rail.scrollWidth <= rail.clientWidth + 2
        ) {
            return;
        }
        gesture = {
            id: event.pointerId,
            left: rail.scrollLeft,
            x: event.clientX,
            dragging: false,
        };
    });

    rail.addEventListener('pointermove', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const distance = event.clientX - gesture.x;
        if (!gesture.dragging && Math.abs(distance) < 6) return;
        if (!gesture.dragging) {
            gesture.dragging = true;
            rail.classList.add('is-dragging');
            try {
                rail.setPointerCapture(event.pointerId);
            } catch {
                // The drag still works while the pointer remains over the rail.
            }
        }
        gesture.pendingLeft = gesture.left - distance;
        if (!dragFrame) dragFrame = window.requestAnimationFrame(applyDrag);
        event.preventDefault();
    });

    rail.addEventListener('dragstart', (event) => {
        if (gesture) event.preventDefault();
    });

    const finish = (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        if (dragFrame) {
            window.cancelAnimationFrame(dragFrame);
            applyDrag();
        }
        suppressClick = gesture.dragging;
        gesture = null;
        rail.classList.remove('is-dragging');
        try {
            if (rail.hasPointerCapture(event.pointerId))
                rail.releasePointerCapture(event.pointerId);
        } catch {
            // The pointer may already have been released by the browser.
        }
        window.setTimeout(() => {
            suppressClick = false;
        });
    };

    rail.addEventListener('pointerup', finish);
    rail.addEventListener('pointercancel', finish);
    rail.addEventListener(
        'click',
        (event) => {
            if (!suppressClick) return;
            event.preventDefault();
            event.stopPropagation();
            suppressClick = false;
        },
        true,
    );

    if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(() => updateScrollableRails());
        rail.zirbelinoResizeObserver = observer;
        observer.observe(rail);
    }
    updateScrollableRails();
}
